import { Component } from "@angular/core";

@Component({
    selector: 'app-easter-tnc',
    imports: [],
    styleUrls: ['./tnc.component.scss'],
    template: `
        <div class="tnc-gradient tw-py-4 tw-px-5 md:tw-px-6 lg:tw-px-10 upper-side-shadow-top">
            <h2 class="tw-font-poppins tw-text-center tw-text-neutral-700 tnc-title">
                TERMS & CONDITIONS APPLY
            </h2>
        </div>
        <div class="tw-w-full down-arrow"></div>
        <div class="tw-py-10 tw-px-5 md:tw-px-28 lg:tw-px-48" style="background-color: #ededed;">
            <ul class="tw-list-disc tw-text-lg tw-font-poppins tw-pl-5">
                <li>The promo code EASTER10 entitles customers to 10% off their total order value.</li>
                <li>Minimum order value of £1000 is required for the code to be applied.</li>
                <li>The discount is applied instantly at checkout upon entering a valid promo code.</li>
                <li>This offer is valid from Friday, 27th March 2026 to Sunday, 19th April 2026.</li>
                <li>The offer is applicable across all eligible products on the Nustone website unless stated otherwise.</li>
                <li>This promotion cannot be combined with any other discount codes, affiliate offers, or trade pricing.</li>
                <li>Nustone reserves the right to amend or withdraw this offer at any time without prior notice.</li>
                <li>Standard delivery and return policies apply.</li>
            </ul>
        </div>
      `
})
export class EasterTncComponent { }
